import React from 'react';
import GivingCampaignTypeSelector from '../components/GivingCampaignTypeSelector';

const GivingCampaignTypeSelectorApp = (props) => (
  <GivingCampaignTypeSelector {...props} />
);

export default GivingCampaignTypeSelectorApp;
